export default __webpack_public_path__ + "static/eventImg2-a128472ffa7a799daf917e0e30520a16.svg";